import {
  type AccountResponse,
  accountResponseSchema,
  type UpdateAccountBody,
  workerUpdateFieldsSchema,
} from "@clipboard-health/contract-payment-service";
import { patch } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useGetWorker } from "@src/appV2/Worker/api/useGetWorker";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";

export function useUpdatePaymentServiceAccount(
  options: UseMutationOptions<AccountResponse, AxiosError, UpdateAccountBody> = {}
) {
  const { userId: workerId } = useDefinedWorker();

  const { refetch: refetchWorker } = useGetWorker({
    enabled: false,
  });

  return useMutation({
    mutationKey: ["update-payment-service-account", workerId],
    mutationFn: async (data: UpdateAccountBody) => {
      const url = `${environmentConfig.REACT_APP_PAYMENTS_API_URL}/accounts/${workerId}`;

      const response = await patch({
        url,
        data,
        requestSchema: workerUpdateFieldsSchema,
        responseSchema: accountResponseSchema,
      });

      await refetchWorker();

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.UPDATE_PAYMENT_SERVICE_ACCOUNT_FAILURE,
    },
    ...options,
  });
}
